import PageContainer from "components/PageContainer";
import CustomTableGrid from "routes/custom_tables/grid/CustomTableGrid";
import { TABLE_PAGE_CONTAINER_HEIGHT } from "constants/Constants";

// The grid an active linked tab renders: rows of `slug` pinned to those
// whose relationship column (`fieldId`) points at this record.
//
// The default ITEMS_TAB height assumes a sibling tab menu (~47px) inside
// the same parent; pages whose tab panel already excludes the menu (the
// shadcn-Tabs row detail) override it via `containerStyles`.
const LinkedTableView = ({ slug, fieldId, recordId, containerStyles }) => (
  <PageContainer
    styles={{
      height: TABLE_PAGE_CONTAINER_HEIGHT.ITEMS_TAB,
      padding: "14px 0px 0px 0px",
      ...containerStyles,
    }}
  >
    <CustomTableGrid
      slug={slug}
      lockedFilters={{ [fieldId]: Number(recordId) }}
    />
  </PageContainer>
);

export default LinkedTableView;
